import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import Scrollbars, { ScrollbarProps as ScrollbarsProps } from 'react-custom-scrollbars-2';

interface ScrollbarProps extends ScrollbarsProps {
  autoHide?: boolean;
  className?: string;
}

const Scrollbar = ({ children, autoHide, className, ...rest }: PropsWithChildren<ScrollbarProps>) => {
  const shouldAutoHide = autoHide ?? !className?.split(/\s+/).filter(Boolean).includes('table-scrollbar');

  return (
    <Scrollbars
      autoHide={shouldAutoHide}
      renderTrackVertical={(props) => <div {...props} className="track-vertical h-100 rounded" />}
      className={classNames('custom-scrollbar', className)}
      {...rest}
    >
      {children}
    </Scrollbars>
  );
};

export default Scrollbar;
